import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { ProductDataLeasing } from '@app/domain/model/eshop/transport/ProductDataLeasing';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';
import { FormState } from '@app/lib/form/contracts/FormState';
import {
    purchaseHomeInsurance,
    PurchaseHomeInsuranceResult,
} from '@app/service/eshop/home/actions/purchaseHomeInsurance';
import { HomeInsuranceRequestResult } from '@app/service/eshop/home/actions/requestHomeInsurance';

export function createEnhancedFormAction(
    discountCodeData: DiscountCodeData,
    requestResult: Nullable<HomeInsuranceRequestResult>,
    defaultConstructionType: Nullable<string>,
    selectedRiders: ProductDataRider[],
    pledgedToBank: Nullable<string>,
    selectedLeasing: Nullable<string>,
    leasings: ProductDataLeasing[],
) {
    return async (prevState: FormState<PurchaseHomeInsuranceResult>, formData: FormData) => {
        if (discountCodeData.validTravelCode) {
            formData.append('discountCode', discountCodeData.validTravelCode);
        }

        if (pledgedToBank) {
            formData.append('pledgedToBank', pledgedToBank);
        }

        if (selectedLeasing) {
            const leasing = leasings.find(leasing => leasing.code === selectedLeasing);
            if (leasing) {
                formData.append('leasing', leasing.code);
                formData.append('leasingName', leasing.name);
            }
        }

        if (defaultConstructionType) {
            formData.append('defaultConstructionType', defaultConstructionType);
        }

        if (selectedRiders.length > 0) {
            selectedRiders.forEach((rider: ProductDataRider) => {
                formData.append(
                    'selectedRiders',
                    JSON.stringify({
                        code: rider.typeCode,
                        id: rider.riderGuid,
                    }),
                );
            });
        }

        return purchaseHomeInsurance(prevState, formData, requestResult);
    };
}
